<template>
  <div class="flex flex-col gap-4 text-left" data-testid="unidentified-coverage-details">
    <!--
      Mesma reserva da faixa dos botões flutuantes do detalhe (ver o
      #duty-details-section no stationDetailsModal): no desktop eles ficam
      \`absolute right-[2.5vw] top-[11vh]\` e, com o "⋯" expandido, descem até a
      linha dos valores. Sem a reserva, o pino/histórico cobriam o chip do tipo
      e o lápis cobria "Liberar vaga". Só o card e a linha de valores: as seções
      bloqueadas ficam abaixo da faixa e alcançam a borda direita.
    -->
    <div
      class="flex flex-col gap-4"
      :class="reserveActionsLane ? 'md:pr-[calc(2.5vw_+_32px)]' : ''"
      data-testid="unidentified-actions-lane"
    >
      <UnidentifiedCoverageCard
        :responsible-name="responsibleName"
        :note="note"
        :station-type-label="stationTypeLabel"
      >
        <template v-if="showActions">
          <button
            v-if="canIdentify"
            type="button"
            class="rounded-md bg-primary px-3 py-1.5 text-sm font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="actionsDisabled"
            data-testid="unidentified-identify-button"
            @click="emit('identify')"
          >
            Identificar médico
          </button>
          <button
            v-if="canEditResponsible"
            type="button"
            class="rounded-md border border-solid border-primary30 bg-white px-3 py-1.5 text-sm font-semibold text-primary30 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="actionsDisabled"
            data-testid="unidentified-edit-responsible-button"
            @click="emit('editResponsible')"
          >
            Editar responsável
          </button>
          <button
            v-if="canRelease"
            type="button"
            class="ml-auto rounded-md border border-solid border-negative bg-white px-3 py-1.5 text-sm font-semibold text-negative disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="actionsDisabled"
            data-testid="unidentified-release-button"
            @click="emit('release')"
          >
            Liberar vaga
          </button>
        </template>
      </UnidentifiedCoverageCard>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div class="flex flex-col"><span class="font-bold">Time</span><span>Externo</span></div>
        <div class="flex flex-col">
          <span class="font-bold">Posição</span><span>{{ positionName || 'Não definida' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Turno</span><span>{{ shiftName || 'Não definido' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Valor de referência</span>
          <span data-testid="unidentified-reference-value"
            >{{ formatCurrencyOrDash(referenceValue) }} (fora dos totais)</span
          >
        </div>
      </div>
    </div>

    <section
      v-for="section in LOCKED_SECTIONS"
      :key="section.testId"
      class="rounded-lg border border-dashed border-lightGray30 bg-[#FAFAFB] px-3 py-2.5"
      :data-testid="section.testId"
    >
      <p class="text-sm font-bold text-gray-500">{{ section.title }}</p>
      <p class="text-sm text-gray-500">{{ section.text }}</p>
    </section>
  </div>
</template>

<script setup lang="ts">
import UnidentifiedCoverageCard from '@/components/Coverage/UnidentifiedCoverageCard.vue'
import { formatCurrencyOrDash } from '@/utils/formatters'

withDefaults(
  defineProps<{
    responsibleName?: string | null
    note?: string | null
    stationTypeLabel?: string | null
    positionName?: string | null
    shiftName?: string | null
    referenceValue: number | null
    showActions: boolean
    canIdentify: boolean
    canEditResponsible: boolean
    canRelease: boolean
    actionsDisabled?: boolean
    /** Reserva a faixa dos botões flutuantes do detalhe (só no desktop). */
    reserveActionsLane?: boolean
  }>(),
  {
    responsibleName: null,
    note: null,
    stationTypeLabel: null,
    positionName: null,
    shiftName: null,
    actionsDisabled: false,
    reserveActionsLane: false
  }
)

const emit = defineEmits<{ identify: []; editResponsible: []; release: [] }>()

const LOCKED_SECTIONS = [
  {
    testId: 'unidentified-locked-registration',
    title: 'Registro de plantão (check-in / check-out)',
    text: 'Bloqueado: não há médico para registrar ponto. Identifique o médico para liberar.'
  },
  {
    testId: 'unidentified-locked-activity',
    title: 'Registro de Atividade',
    text: 'Bloqueado: sem cobrança de envio e sem vínculo de folha enquanto sem identificação.'
  },
  {
    testId: 'unidentified-locked-post-station',
    title: 'Pós-plantão',
    text: 'Não avaliado: plantões sem identificação ficam fora do pós-plantão e do NPS.'
  }
]
</script>
